import React from 'react';
import { Button } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Box from '@mui/material/Box';

const sx = {
  buttonNav: {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    opacity: '0.8',
    '&:hover': {
      opacity: '1',
    },
  },
};

export function PdfViewerNavigation({
  goToPrevPage,
  goToNextPage,
  pdfViewerNavigationFixed,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBlock: '16px',
        paddingInline: '8px',
        position: pdfViewerNavigationFixed ? 'fixed' : 'absolute',
        top: '50%',
        left: '5px',
        right: '20px',
        transform: 'translateY(-50%)',
        zIndex: 20,
      }}
    >
      <Button variant="contained" onClick={goToPrevPage} sx={sx.buttonNav}>
        <NavigateBeforeIcon />
      </Button>
      <Button variant="contained" onClick={goToNextPage} sx={sx.buttonNav}>
        <NavigateNextIcon />
      </Button>
    </Box>
  );
}
